export const debounceDelay = 500;
export const animationRuntime = 301;
export const searchTextMinLength = 1;
export const contentResultsLimit = 5;
export const contentSearchSite = 'thailand_ecommerce';
export const popularSearchKeywordKeys = [
  'search.popularSearchKeywords.protein',
  'search.popularSearchKeywords.skin',
  'search.popularSearchKeywords.artistry',
  'search.popularSearchKeywords.lotion',
  'search.popularSearchKeywords.green',
];
